if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"guest","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(0|1229|1918|2555|3964|4326|453|5005|6790|9542)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}